/**
 * EasyTripGo - Hoppy Currency Display
 * USD primary, local currency secondary.
 */

(() => {
  const selector = 'product-price .price';

  function getCurrency(text) {
    const value = (text || '').trim();

    if (/\bUSD\b/i.test(value)) return 'USD';
    if (/\bEUR\b/i.test(value) || /€/.test(value)) return 'EUR';
    if (/\bCNY\b/i.test(value) || /CN¥/.test(value)) return 'CNY';
    if (/\bCAD\b/i.test(value) || /CA\$/.test(value)) return 'CAD';
    if (/\bSGD\b/i.test(value) || /S\$/.test(value)) return 'SGD';

    return null;
  }

  function updatePrice(container) {
    const money = container.querySelector(':scope > .money');
    const original = container.querySelector(':scope > .original-price');

    if (!money || !original) return;

    // Remove parentheses from original USD price.
    const text = original.textContent.trim();

    if (text.startsWith('(') && text.endsWith(')')) {
      original.textContent = text.slice(1, -1);
    }

    // Detect whether Hoppy is currently displaying USD.
    const currency = getCurrency(money.textContent);

    container.classList.toggle(
      'etg-usd-only',
      currency === 'USD'
    );
  }

  function updateAll() {
    document.querySelectorAll(selector).forEach(updatePrice);
  }

  function init() {
    updateAll();

    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;

      scheduled = true;

      requestAnimationFrame(() => {
        scheduled = false;
        updateAll();
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();